
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[staticSite]",
      function () {
        return require("private-next-pages/[staticSite].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[staticSite]"])
      });
    }
  